import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Form,
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  deleteUnitType,
  getUnitsTypes,
  updateUnitType,
} from "src/slices/UnitsTypes/thunk";
import { useDispatch } from "react-redux";
import { AppDispatch } from "src";

const ModalValidation = ({
  selectedUnit,
  setModal,
  setSuccessDelete,
  setErrorDelete,
  setSuccessUpdate,
  setErrorUpdate,
}: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const validation = useFormik({
    initialValues: {
      name: `${selectedUnit.name}`,
      level: `${selectedUnit.level}`,
      key: `${selectedUnit.key}`,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Por favor, insira o nome"),
      level: Yup.string().required("Por favor, insira o nível"),
      key: Yup.string().required("Por favor, insira a chave"),
    }),
    onSubmit: values => {
      dispatch(updateUnitType({ ...values, id: selectedUnit.id })).then(
        response => {
          setModal(false);
          if (
            typeof response.payload === "string" &&
            response.payload.includes("Request failed with")
          ) {
            setErrorUpdate(true);
          } else {
            setSuccessUpdate(true);
            dispatch(getUnitsTypes());
          }
        }
      );
    },
  });

  const handleDelete = () => {
    dispatch(deleteUnitType(selectedUnit.id)).then(response => {
      setModal(false);
      if (
        typeof response.payload === "string" &&
        response.payload.includes("Request failed with")
      ) {
        setErrorDelete(true);
      } else {
        setSuccessDelete(true);
        dispatch(getUnitsTypes());
      }
    });
  };

  return (
    <React.Fragment>
      <Form
        className="needs-validation"
        onSubmit={e => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <Col>
          <FormGroup className="mb-3">
            <Label htmlFor="validationCustom01">Nome</Label>
            <Input
              name="name"
              placeholder="Nome"
              type="text"
              className="form-control"
              id="validationCustom01"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.name || ""}
              invalid={
                validation.touched.name && validation.errors.name ? true : false
              }
            />
            {validation.touched.name && validation.errors.name ? (
              <FormFeedback type="invalid">
                {validation.errors.name}
              </FormFeedback>
            ) : null}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup className="mb-3">
            <Label htmlFor="validationCustom04">Chave</Label>
            <Input
              name="key"
              placeholder="Chave"
              type="text"
              className="form-control"
              id="validationCustom04"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.key || ""}
              invalid={
                validation.touched.key && validation.errors.key ? true : false
              }
            />
            {validation.touched.key && validation.errors.key ? (
              <FormFeedback type="invalid">
                {validation.errors.key}
              </FormFeedback>
            ) : null}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup className="mb-3">
            <Label htmlFor="validationCustom03">Nível</Label>
            <Input
              name="level"
              placeholder="Nível"
              type="select"
              className="form-control"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.level || ""}
              invalid={
                validation.touched.level && validation.errors.level
                  ? true
                  : false
              }
            >
              <option value="">Selecione</option>
              <option value="1">Nivel 1</option>
              <option value="2">Nivel 2</option>
              <option value="3">Nivel 3</option>
              <option value="4">Nivel 4</option>
              <option value="5">Nivel 5</option>
              <option value="6">Nivel 6</option>
            </Input>
            {validation.touched.level && validation.errors.level ? (
              <FormFeedback type="invalid">
                {validation.errors.level}
              </FormFeedback>
            ) : null}
          </FormGroup>
        </Col>

        <div className="d-flex flex-wrap gap-2">
          <Button color="primary" type="submit">
            Submiter
          </Button>
          <Button type="button" color="danger" onClick={handleDelete}>
            Apagar
          </Button>
        </div>
      </Form>
    </React.Fragment>
  );
};

export default ModalValidation;
